/* eslint-disable */

/** unique or primary key constraints on table "argo.hasura_permission" */
export enum ArgoHasuraPermissionConstraint {
  /** unique or primary key constraint on columns "name" */
  HasuraPermissionNameKey = 'hasura_permission_name_key'
}

/** select columns of table "argo.hasura_permission" */
export enum ArgoHasuraPermissionSelectColumn {
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name'
}

/** update columns of table "argo.hasura_permission" */
export enum ArgoHasuraPermissionUpdateColumn {
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name'
}

